import { DEFAULT_PATH } from 'utils/consts/path'
import type { RootState } from 'store'

export const getStep2Active = (state: RootState) =>
  state?.company?.values?.step2Active
export const getNextContentVisible = (state: RootState) =>
  state?.company?.values?.nextContentVisible ?? false

export const getAvatar = (state: RootState) => state?.company?.values?.avatar
export const getVerificationStatus = (state: RootState) =>
  state?.company?.values?.verificationStatus

export const getCountry = (state: RootState) => state?.company?.values?.country
export const getCategory = (state: RootState) =>
  state?.company?.values?.category
export const getFormDirty = (state: RootState) =>
  state?.company?.values?.isDirty
export const getCoincidesWithLegalName = (state: RootState) =>
  state?.company?.values?.coincidesWithLegalName ?? false
export const getRegistrationNumber = (state: RootState) =>
  state?.company?.values?.registrationNumber ?? ''
export const getLegalEntity = (state: RootState) =>
  state?.company?.values?.legalEntity
export const getTradeName = (state: RootState) => {
  const values = state?.company?.values
  return (
    (values?.coincidesWithLegalName ? values?.legalName : values?.tradeName) ??
    ''
  )
}
export const getVat = (state: RootState) => state?.company?.values?.vat ?? ''
export const getWebsite = (state: RootState) =>
  state?.company?.values?.website ?? ''
export const getNoWebsite = (state: RootState) =>
  state?.company?.values?.noWebSite ?? false
export const getDefaultWebsite = (state: RootState) => {
  const companyId = state.company?.values?.id
  return companyId
    ? `${window.location.origin}${DEFAULT_PATH}/company/${companyId}`
    : '-'
}
export const getActivityCode = (state: RootState) =>
  state?.company?.values?.activityCode ?? ''
export const getBranchNumber = (state: RootState) =>
  state?.company?.values?.branchNumber ?? ''
export const getLegalName = (state: RootState) =>
  state?.company?.values?.legalName ?? ''
export const getLegalAddress = (state: RootState) =>
  state?.company?.values?.legalAddress ?? ''
export const getLegalEntityForm = (state: RootState) =>
  state?.company?.values?.legalEntityForm
export const getEmail = (state: RootState) =>
  state?.company?.values?.email ?? ''
export const getRepresentativeUser = (state: RootState) =>
  state?.company?.values?.representativeUser
export const getPhone = (state: RootState) =>
  state?.company?.values?.phone ?? ''
export const getLogo = (state: RootState) => state?.company?.values?.logo ?? ''
export const getPostAddress = (state: RootState) =>
  state?.company?.values?.postAddress ?? ''
export const getPostCode = (state: RootState) =>
  state?.company?.values?.postCode ?? ''
export const getTradeNameSelectedFromList = (state: RootState) =>
  state?.company?.values?.tradeNameSelectedFromList
export const getSameAsLegalAddress = (state: RootState) =>
  state?.company?.values?.sameAsLegalAddress ?? false
export const getOfficialTradeNames = (state: RootState) =>
  state?.company?.values?.officialTradeNames ?? []

export const getWritePolicy = (state: RootState) =>
  state?.company?.values?.writePolicy ?? {}
export const getLogoLoading = (state: RootState) =>
  state?.company?.values?.logoLoading ?? false

export const getLogoError = (state: RootState) => state?.company?.errors?.logo
export const getAvatarError = (state: RootState) =>
  state?.company?.errors?.avatar
export const getAvatarLoading = (state: RootState) =>
  state?.company?.values?.avatarLoading ?? false
export const getCountryError = (state: RootState) =>
  state?.company?.errors?.country
export const getTradeNameError = (state: RootState) =>
  state?.company?.errors?.tradeName
export const getRegistrationNumberError = (state: RootState) =>
  state?.company?.errors?.registrationNumber
export const getVatError = (state: RootState) => state?.company?.errors?.vat
export const getWebsiteError = (state: RootState) =>
  state?.company?.errors?.website
export const getActivityCodeError = (state: RootState) =>
  state?.company?.errors?.activityCode
export const getBranchNumberError = (state: RootState) =>
  state?.company?.errors?.branchNumber
export const getCategoryError = (state: RootState) =>
  state?.company?.errors?.category
export const getLegalAddressError = (state: RootState) =>
  state?.company?.errors?.legalAddress
export const getLegalEntityFormError = (state: RootState) =>
  state?.company?.errors?.legalEntityForm
export const getLegalNameError = (state: RootState) =>
  state?.company?.errors?.legalName
export const getEmailError = (state: RootState) => state?.company?.errors?.email
export const getPhoneError = (state: RootState) => state?.company?.errors?.phone
export const getPostAddressError = (state: RootState) =>
  state?.company?.errors?.postAddress ?? ''
export const getPostCodeError = (state: RootState) =>
  state?.company?.errors?.postCode
